export const GET_YEAR = 'GET_YEAR';
